/**
 * Home page - Featured inventory
 * ===================================
 * Loads inventory, renders the first 6 vehicles into #featuredGrid,
 * then wires up pre-qualify triggers.
 */

import { loadInventory } from '../util/inventory-loader.ts';
import { buildVehicleCard, initPrequalTriggers } from '../util/vehicle-card.ts';

loadInventory()
  .then((data) => {
    const vehicles = (data.inventory || []).slice(0, 6);
    const grid = document.getElementById('featuredGrid');
    if (!grid) return;
    if (!vehicles.length) {
      grid.innerHTML =
        '<p style="grid-column:1/-1;text-align:center;padding:40px;color:var(--secondary);">No vehicles available at this time.</p>';
      return;
    }
    grid.innerHTML = vehicles.map(buildVehicleCard).join('');
    initPrequalTriggers(grid);
  })
  .catch((err) => {
    console.error('[Inventory] Failed to load featured vehicles:', err);
    const grid = document.getElementById('featuredGrid');
    if (!grid) return;
    grid.innerHTML =
      '<p style="grid-column:1/-1;text-align:center;padding:40px;color:var(--secondary);">Unable to load vehicles. Please refresh the page.</p>';
  });
